import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./index.css";
import { installAdminMocks } from "./mock/install";
import { mountMockPanel } from "./mock/MockPanel";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Could not find #root element");
}

// Dev-only mock backend. The localStorage flag alone is a RUNTIME check, so
// without this compile-time guard the whole mock ships to production and
// anyone setting rp.mock=1 there gets a console full of invented clients.
// Both modules are side-effect-free, so with DEV folded to false Rollup drops
// them from the bundle entirely. installAdminMocks patches
// ApiClient.prototype, so it has to run before the first render — keep these
// static imports rather than awaiting a dynamic one.
if (import.meta.env.DEV) {
  installAdminMocks();
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if (import.meta.env.DEV) {
  mountMockPanel();
}
